import { LessonListRow } from "@/components/lesson/LessonListRow";
import { CONTENT_MAX_WIDTH } from "@/lib/useDeviceType";
import { Lesson, UserLesson } from "@/types";
import React from "react";
import { YStack } from "tamagui";
import { ContentTitle } from "@/components/ui/Typography";

interface LessonListViewProps {
  lessons: Lesson[];
  onPressLesson: (lesson: Lesson) => void;
  isMobile: boolean;
  userLessonsMap?: Record<number, UserLesson>;
  showResultsCount?: boolean;
  searching?: boolean;
  hidePublishedDate?: boolean;
  showCourseColor?: boolean;
}

export const LessonListView: React.FC<LessonListViewProps> = ({
  lessons,
  onPressLesson,
  isMobile,
  userLessonsMap = {},
  showResultsCount = false,
  searching = false,
  hidePublishedDate = false,
  showCourseColor = false,
}) => {
  if (lessons.length === 0 && !searching && showResultsCount) {
    return (
      <YStack w="100%" maw={CONTENT_MAX_WIDTH} mx="auto" py={16} px={16}>
        <ContentTitle color="$color">
          0 Results
        </ContentTitle>
      </YStack>
    );
  }

  if (lessons.length === 0) {
    return null;
  }

  return (
    <YStack
      w="100%"
      maw={CONTENT_MAX_WIDTH}
      mx="auto"
      py={showResultsCount ? 16 : 0}
      px={showResultsCount ? 16 : 0}
      gap={32}
    >
      {showResultsCount && (
        <ContentTitle color="$color">
          {lessons.length} Results
        </ContentTitle>
      )}
      {lessons.map((item) => (
        <LessonListRow
          key={item.id}
          item={item}
          onPress={() => onPressLesson(item)}
          userLesson={userLessonsMap[item.id]}
          isMobile={isMobile}
          hidePublishedDate={hidePublishedDate}
          showCourseColor={showCourseColor}
        />
      ))}
    </YStack>
  );
};
